// Sales model + service area. The radius input is only meaningful when
// coverage_type == 'radius_based' — we show a hint rather than hiding it.
import React from 'react';
import {
  NumberField, SelectField, SwitchField, TextField, ListField,
} from './fields';
import { COVERAGE_TYPES, SALES_MODELS } from './constants';

export default function ServiceAreaSection({ value, dealerType, onChange }) {
  const set = (key) => (v) => onChange({ ...value, [key]: v });
  const expectedSalesModel =
    dealerType === 'broker_remote' ? 'remote_delivery' : 'in_store';
  const misaligned = value.sales_model && value.sales_model !== expectedSalesModel;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <SelectField
          label="Sales model"
          value={value.sales_model}
          onChange={set('sales_model')}
          options={SALES_MODELS}
        />
        <SelectField
          label="Coverage type"
          value={value.coverage_type}
          onChange={set('coverage_type')}
          options={COVERAGE_TYPES}
        />
      </div>
      {misaligned && (
        <p className="text-xs text-yellow-600">
          Heads up: publish will reject this — {dealerType.replace('_', ' ')} dealers
          must use <code>{expectedSalesModel}</code>.
        </p>
      )}

      {dealerType === 'local_retail' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextField label="Address" value={value.address} onChange={set('address')} />
          <TextField label="City" value={value.city} onChange={set('city')} />
          <TextField label="Province" value={value.province} onChange={set('province')} />
          <TextField label="Postal code" value={value.postal_code} onChange={set('postal_code')} />
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <ListField
          label="Provinces served"
          value={value.provinces}
          onChange={set('provinces')}
          placeholder="ON, QC, BC"
        />
        <NumberField
          label="Radius (km) — required for radius_based coverage"
          value={value.radius_km}
          onChange={set('radius_km')}
          min={0}
          max={10000}
        />
      </div>

      <SwitchField
        label="Delivery available"
        description="Dealer can deliver units to the customer."
        value={value.delivery_available}
        onChange={set('delivery_available')}
      />
    </div>
  );
}
